export default () => import(/* webpackChunkName: 'coffee/activities/harmony/harmony-coupon' */ './HarmonyCoupon');
